import { Component, ElementRef, EventEmitter, Input, OnChanges, Renderer2, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SnapshotService } from '../../Services/snapshot.service';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import * as _ from 'lodash';
import { LoaderService } from 'src/app/common/services/loader.service';

@Component({
  selector: 'app-custom-output-icons',
  templateUrl: './custom-output-icons.component.html',
  styleUrls: ['./custom-output-icons.component.css']
})
export class CustomOutputIconsComponent implements OnChanges {
  constructor(
    public _configService: SnapshotService,
    private _customService: CustomsnapshotService,
    private renderer: Renderer2,
    private _loaderService: LoaderService
  ) {

  }
  @Input() data: any;
  @Input() widgetchartname: string = "";
  @Input() id: any;
  @Input() alldata: any;
  @Input() datafromLayout: any;
  infoTextTitle: string = '';
  showExpandPopup = false;
  visualization: any;
  infoClicked: boolean = false;
  infoTextMessage: string = "";
  // id: any;
  item: any;
  elementList: any = false;
  customization: any = {}
  isdropDown: any = false;
  dropDownItems: any = [];
  inputPopup: boolean = false;
  brandList: any = []
  selectedBrand: any;
  originalWidgetChartName: string = '';
  isSingleFunnelOrMultipleWidget: boolean = false;
  isSingleFunnel: boolean = false;
  defaultSorting = 0;
  isSortAvailable : boolean = false;
  ngOnInit() {
    this._customService.getBrandList(this.id).subscribe((list) => {
      let brandList = list[0];
      this.selectedBrand = list[1];
      this.brandList = [];
      if (brandList) {
        brandList.forEach((b: any) => {
          this.brandList.push({
            option: b,
            checked: b == this.selectedBrand ? true : false
          })
        })
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.customization = JSON.parse(this.data?.customizationProperties);
      if( this.data.elementList != undefined ){
        this.data.elementList.forEach((item:any) => {
          if(item.item == "Sorting"){
            this.isSortAvailable = true;
          }
        })
      }

      if( this.data.sortingOrder != undefined ){
        this.data.sortingOrder = (this.data.sortingOrder + 1)%3;
      }
      if (this.customization?.additionalGroup && this.data.elementList == undefined || this.data.elementList?.length == 0) {
        // if (this.customization?.showLegend !== undefined) {
        //   // Add the "Show Legend" property to the additionalGroup object

        //   this.customization.additionalGroup['showLegend'] = this.customization.showLegend;
        // }
        // let elementListItems = Object.keys(this.customization?.additionalGroup);
        let elementListItems = Object.keys(this.customization?.additionalGroup || {}).filter(
          key => this.customization.additionalGroup[key] === true || this.customization.additionalGroup[key] != false
        );
        // elementListItems.push(Object.keys(this.customization?.additionalGroup || {}).filter(
        //   key => this.customization.additionalGroup[key] === true
        // ))
        if (elementListItems) {
          elementListItems.forEach((e: any) => {
            // if(e == "FreezeFirstColumn" || e=="FreezeFirstRow" || e=="HideNA" || e=="Transpose"){
            //   this.elementListItems.push(
            //     {
            //       item: e,
            //       selected: this.customization?.additionalGroup[e],
            //       isdropDown: false,
            //       options: []
            //     }
            //   );
            // }
            // else if( e== "ColumnHeaderSorting"){
            //   this.elementListItems.push(
            //     {
            //       item: e,
            //       selected: false,
            //       isdropDown: false,
            //       options: [
            //         { item: "Ascending", selected: false },
            //         { item: "Descending", selected: false },
            //         { item: "Default", selected: true },
            //       ]
            //     }
            //   );
            // }
            if (e != "Sorting" && e != "ColumnHeaderSorting" && e != "TrendlineinExports" && e != "showLegend") {
              this.elementListItems.push(
                {
                  item: e,
                  selected: false,
                  isdropDown: false,
                  options: []
                }
              );
            }
            else if (e != "ColumnHeaderSorting" && e != "TrendlineinExports" && e != "showLegend") {
              this.elementListItems.push(
                {
                  item: e,
                  selected: false,
                  isdropDown: false,
                  options: [
                    { item: "Ascending", selected: false },
                    { item: "Descending", selected: false },
                    { item: "Default", selected: true },
                  ]
                }
              );
            }
          })
        }
        // Sort this.elementListItems based on chartOptions
        this.elementListItems = this.elementListItems
          .map((item: any) => {
            // Find the matching object from chartOptions
            const matchedOption = this._customService.elementLists.find(option =>
              option.name.replace(/\s+/g, '').toLowerCase() === item.item.replace(/\s+/g, '').toLowerCase()
            );

            // If a match is found, add the label and sortId
            if (matchedOption) {
              return {
                ...item,
                label: matchedOption.name, // Add label from chartOptions
                sortId: matchedOption.sortId // Add sortId from chartOptions
              };
            }

            // If no match, return the item with a high sortId to move it to the end
            return {
              ...item,
              label: item.item, // Use the item name as the label
              sortId: Number.MAX_SAFE_INTEGER
            };
          })
          .sort((a: any, b: any) => a.sortId - b.sortId); // Sort based on sortId


        this.data.trendlineOutputView = this.customization?.trendlineOutputView;
        this.data.elementList = this.elementListItems;
        this.data.sortingOrder = 0;
        this.data.elementList.forEach((item:any) => {
          if(item.item == "Sorting"){
            this.isSortAvailable = true;
          }
        })
        if (this._configService.selectedSnapshotType.toLowerCase().includes("multi")) {          
          if (!this.data.metric.some((dd: any) =>
            dd.metric_value.some((mv: any) => mv.data.some((data: any) => data.hasOwnProperty('defaultIndex')))
          )) {
            // If 'defaultIndex' doesn't exist in any data entry, add it with incremental values starting from 0
            this.data.metric = this.data.metric.map((dd: any) => ({
              ...dd,
              metric_value: dd.metric_value.map((mv: any) => ({
                ...mv,
                data: mv.data.map((data: any, index: number) => ({
                  ...data,
                  defaultIndex: index // Assign incremental value starting from 0
                }))
              }))
            }));
          }
        }

      }
    }
    if (changes['id']) {
      this.isSingleFunnelOrMultipleWidget = this.datafromLayout[this.id - 1]?.selectedLayout == 1 ? (this.widgetchartname == "FUNNEL CHART" ? true : false) : true;
      this.isSingleFunnel = this.datafromLayout[this.id - 1]?.selectedLayout == 1 && (this.widgetchartname == "FUNNEL CHART") ? true : false;
    }
    this._customService.getBrandList(this.id).subscribe((list) => {
      let brandList = list[0];
      this.selectedBrand = list[1];
      this.brandList = [];
      if (brandList) {
        brandList.forEach((b: any) => {
          this.brandList.push({
            option: b,
            checked: b == this.selectedBrand ? true : false
          })
        })
      }
    });
  }

  getBrand() {
    if (_.cloneDeep(this.selectedBrand).split("|")[1]) {
      return _.cloneDeep(this.selectedBrand).split("|")[1]
    }
    else {
      return this.selectedBrand;
    }
  }




  toogleDropdown() {
    this.isBrandListdropdownOpen = !this.isBrandListdropdownOpen;
  }


  onCloseIconClick(data: any) {
    this.infoClicked = false;
    this.infoTextMessage = "";
  }

  elementListItems: any = [];
  LengthOf(a: any) {
    if (a) {
      if (Array.isArray(a)) {
        return a.length;
      }
      else if (typeof a === 'object') {
        const keys = Object.keys(a);
        if (keys.length > 0) {
          if (keys.includes("Trendline")) {
            return a.Trendline ? 1 : 0;
          }
          return keys.length;
        }
      }
      return 0;
    } else {
      return 0;
    }
  }
  isBrandListdropdownOpen: boolean = false;
  checkBoxesbrandListClicked(event: any, item: any) {
    this.brandList.forEach((b: any) => {
      if (b.option == item.option) {
        b.checked = event.target.checked
        this.selectedBrand = b.option;
        this._customService.updateSelectedBrand(this.id, this.selectedBrand);
      }
      else {
        b.checked = false;
      }
    })

  }

  showExpandPopupFun() {

    //this.infoTextTitle = this.widgetName;

    this.showExpandPopup = true;
  }
  receivedDeleteConfirmation(data: any) {
    this.showExpandPopup = data;

  }

  showelementlist() {
    if (this.LengthOf(this.customization?.additionalGroup) < 1) {
      return;
    }
    
    this.alldata.forEach((d: any) => {
      if (d != this.data) {
        d.showElementList = false;
      }
    });
    this.data.showElementList = this.data.showElementList == undefined ? true : !this.data.showElementList;
    this.elementList = !this.elementList;
    
    event?.stopPropagation();
  }
  closeelementList() {
    this.data.showElementList = false;
    this.elementList = false;
    this.isdropDown = false;
    this.data.elementList.forEach((item: any) => {
      if (item.item == "Sorting") {
        item.selected = false;
        item.isdropDown = false;
      }
    })

  }
  closedropdown(item: any) {
    this.isdropDown = false;
    item.selected = false;
    item.isdropDown = false;
  }
  @Output() elementClickedStatus = new EventEmitter();
  currentElementList: any = [];
  showTrendPoppup: boolean = false;
  trendData: any;
  metricLists: any = [];
  brandLists: any = [];


  sortData(){
    this.defaultSorting = ( this.data.sortingOrder + 1 )%3;
    let sortingOrder = this.defaultSorting == 1 ? 'Ascending' : this.defaultSorting == 2  ? 'Descending' : 'Default';
    let data = {
      data: this.data,
      value: sortingOrder.toLowerCase(),
      key: "sort"
    }
    this.elementClickedStatus.emit(data);
  }
  onSortingClick(item:string){
    this.data.elementList.forEach((e:any) => {
      if(e.item == item){
        this.dropDownItems = e.options;
        this.sortData()
      }
    })
  }
  elementItemSelect(item: any, elementList: any, dropdownContainer: any) {
    this.data.elementList.forEach((e: any) => {
      if (e.item != "Sorting" && e.item == item.item) {
        e.selected = !e.selected;
        if (e.item == "InfoText") {
          this.infoTextMessage = this.customization.infoText;
          e.selected = false;
          this.infoClicked = true;
          this.infoTextTitle = this.data?.widget_name
          console.log(item);
        }
        if (e.item == "XAxisGridlines") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "xaxisgridlines"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "showLegend") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "showLegend"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "FreezeFirstColumn") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "freezeFirstColumn"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "FreezeFirstRow") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "freezeFirstRow"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Transpose") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "Transpose1"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "DataLabelOverlap") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "dataLabelOverlap"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Axes") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "axes"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Sectorfill") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "sectorfill"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        // if (e.item == "TrendlineinExports") {
        //   let data = {
        //     data: this.data,
        //     value: _.cloneDeep(e.selected),
        //     key: "TrendlineinExports"
        //   }
        //   console.log(data);
        //   setTimeout(() => {
        //     this.elementClickedStatus.emit(data);
        //   }, 0);
        // }
        if (e.item == "HideNA") {
          let data = {
            data: this.data,
            value: _.cloneDeep(e.selected),
            key: "hideNA"
          }
          console.log(data);
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "YAxisGridlines") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "yaxisgridlines"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == 'Top10') {
          let data = {
            data: this.data,
            value: e.selected,
            key: "top10"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Trendline") {
          this.originalWidgetChartName = this.data.widgetchart_name;
          this._loaderService.showLoader();
          let widgetchart_name = this.data.widgetchart_name;
          let widgetData = this._configService.widgetData.filter((d: any) => d.widget_name == this.data.widget_name);
          console.log(this._configService.widgetData);
          this._configService.getOutPutData(this._configService.finalLeftPanelSubmitObject.previewData,
            // this._configService.finalLeftPanelSubmitObject.selectedClient,
            // this._configService.finalLeftPanelSubmitObject.selectedStudy,
            this._configService.getDropdownValues()?.clientName,
            this._configService.getDropdownValues()?.studyName,
            this._configService.finalLeftPanelSubmitObject.significance,
            this._configService.finalLeftPanelSubmitObject.isFilteringActive,
            this._configService.finalLeftPanelSubmitObject.DefaultConfidenceLevel,
            this._configService.finalLeftPanelSubmitObject.isTotalBase,
            this._configService.finalLeftPanelSubmitObject.selectedWeight,
            this._configService.finalLeftPanelSubmitObject.weightColumnName,
            this._configService.finalLeftPanelSubmitObject.isBoostFactor,
            this._configService.finalLeftPanelSubmitObject.SignificanceVsReference,
            this._configService.finalLeftPanelSubmitObject.columnLength,
            this._configService.finalLeftPanelSubmitObject.dataArray,
            this._configService.finalLeftPanelSubmitObject.isBrandAnalysis,
            this._configService.finalLeftPanelSubmitObject.isAggregatedData,
            this._configService.finalLeftPanelSubmitObject.isSemiAggregatedData,
            this._configService.finalLeftPanelSubmitObject.isRespondentLevel,
            this._configService.finalLeftPanelSubmitObject.aggregatedVariables,
            this._configService.finalLeftPanelSubmitObject.istimePeriodWave,
            this._configService.finalLeftPanelSubmitObject.widegtconfigdetails,
            this._configService.finalLeftPanelSubmitObject.indexVsBrandReference,
            this._configService.finalLeftPanelSubmitObject.significanceVsBrandReference,
            true,//this._configService.checkTrendEnabled(this.existingData)
            this._configService.widgetPageData,
            widgetData,
            this._configService.finalLeftPanelInputSelectedObject.page,
          ).subscribe((result) => {
            ;

            if (result.Data != null && result.Data != undefined && result.Data != "") {
              let opData = JSON.parse(result.Data);
              opData.forEach((d: any) => {
                if (d.Level1ColChild?.startsWith('Time Period|')) {
                  d.Level1ColChild = d.Level1ColChild.replace('Time Period|', '');
                }
              })
              this._configService.trendOutputDbCallData = opData;
              console.log(opData);
              this.showTrendPoppup = true;
              let m = _.cloneDeep(this._configService.itemWithTrendData[0].find((d: any) => d.widget_name == this.data.widget_name));
              m.metric.forEach((metric: any) => {
                metric.metric_value.forEach((mv: any) => {
                  let opDataMetric = opData.filter((d: any) => 
                    (d.rowChild?.replace(/\s+/g, '')?.toLowerCase().includes(mv.option?.replace(/\s+/g, '')?.toLowerCase())) ||
                    (d.rowChild?.replace(/\s+/g, '')?.toLowerCase().includes(mv.metricName?.replace(/\s+/g, '')?.toLowerCase()))
                  );
                  opDataMetric = opDataMetric.map((d: any) => {
                    return {
                      ...d, // Keep all existing properties
                      data: this._configService.weightToggle(
                        this._configService.getDropdownValues()?.baseType, 
                        this._configService.weightSelected, 
                        d
                      ),
                      data2: this._configService.weightToggleIndex(
                        this._configService.getDropdownValues()?.baseType, 
                        this._configService.weightSelected, 
                        d
                      ),
                      lvl1Child: d.Level1ColChild,
                      colChild: d.colChild,
                      rowChild: d.rowChild
                    };
                  });
                  
                  if(opDataMetric){
                    mv.data = opDataMetric;
                    this._configService.sortTrendTimeporiodData(mv.data);
                  }
                });
              })

              if (m) {
                m.widgetchart_name = 'Line Chart';
                let metricList: any;
                if (widgetchart_name == "spider/radar") {
                  metricList = m.metric.flatMap((metric: any) =>
                    metric.metric_value.map((m: any) => m.option != undefined ? m.option : m.metricName)
                  );
                }
                else {
                  metricList = m.metric.flatMap((metric: any) =>
                    metric.metric_value.map((m: any) => m.option)
                  );
                }
                let brandList = Array.from(new Set(m.metric.flatMap((metric: any) =>
                  metric.metric_value.flatMap((m: any) => m.data.map((d: any) => d.colChild))
                )));
                this.trendData = m;
                console.log(metricList);
                this.metricLists = metricList;
                console.log(brandList);
                this.brandLists = brandList
              }
              this.data.widgetchart_name = 'Line Chart';

            }
            this._loaderService.hideLoader();
          });


         
          e.selected = false;
        }
      }
      else if ((e.item == "Sorting") && e.item == item.item) {
        e.selected = !e.selected;
        e.isdropDown = !e.isdropDown;
        this.isdropDown = e.isdropDown;
        this.dropDownItems = e.options;
        if (e.isdropDown) {
          this.toggleDropdown1(e.isdropDown, elementList, dropdownContainer);
        }
      }
      // else {
      //   if (e.isdropDown) {
      //     // e.selected = false;
      //     e.isdropDown = false;
      //     this.isdropDown = false;
      //   }
      // }
    })
    this._customService.elementListItems = _.cloneDeep(this.elementListItems);
    console.log("currentElementList", this.currentElementList);
    console.log(item);
    event?.stopPropagation();
  }
  showDropdown: boolean = false;
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  toggleDropdown1(isDropdown: any, elementList: any, dropdownContainer: any): void {
    this.showDropdown = !this.showDropdown;
    if (isDropdown) {
      // Calculate position of the clicked parent element
      const rect = elementList?.getBoundingClientRect();

      setTimeout(() => {
        const dropdown = this.dropdownContainer.nativeElement;
        console.log(dropdown);
        // Calculate available space
        const viewportWidth = window.innerWidth;
        const dropdownWidth = dropdown.offsetWidth;

        let leftPosition: number;

        if (rect.right + dropdownWidth <= viewportWidth) {
          // Enough space on the right
          leftPosition = rect.right;
        } else {
          // Not enough space, position to the left
          leftPosition = rect.left - dropdownWidth;
        }

        // Set dropdown position
        this.renderer.setStyle(dropdown, 'position', 'fixed');
        this.renderer.setStyle(dropdown, 'top', `${rect.top}px`);
        this.renderer.setStyle(dropdown, 'left', `${leftPosition - 10}px`);
        this.renderer.setStyle(dropdown, 'z-index', '10');
        this.renderer.setStyle(dropdown, 'visibility', 'visible'); // Make sure dropdown is visible
      })



    }
  }

  getUniqueBrand(brandList: any[]): any[] {
    const seen = new Set<string>();
    return brandList.filter((item) => {
      if (seen.has(item.option)) {
        return false;
      }
      seen.add(item.option);
      return true;
    });
  }


  checkElementStatus() {
    if (this.elementList && this.LengthOf(this.customization?.additionalGroup) > 0) {
      if (this.LengthOf(this.customization?.additionalGroup) == 1) {
        if (Object.keys(this.customization?.additionalGroup).includes("InfoText")) {
          if (this.customization?.additionalGroup?.InfoText != "") {
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return true;
        }
      }
    }
    else {
      return false;
    }
    return true;
  }

  dropDownSelect(item: any) {
    this.dropDownItems.forEach((d: any) => {
      if (d.item == item.item) {
        d.selected = true;
        let data = {
          data: this.data,
          value: d.item.toLowerCase(),
          key: "sort"
        }
        this.elementClickedStatus.emit(data);
        this.data.elementList.forEach((item: any) => {
          if (item.item == "Sorting") {
            item.selected = false;
            item.isdropDown = false;
          }
        })
      }
      else {
        d.selected = false;
      }
    })
    event?.stopPropagation();
  }


  hide(data: any) {
    this.showTrendPoppup = data;
    this.data.widgetchart_name = this.originalWidgetChartName;
  }
}
